<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">

                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data"
                            class="workflow-tabs">
                            <div class="tab-content">
                                <input type="hidden" name="_token" :value="csrf">
                                <input v-if="this.editing" type="hidden" name="_method" value="PUT">

                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{ __('forms.Question.title') }}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[name]"
                                                :value="this.name">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{ __('forms.Question.description') }}</label>
                                            <input type="text" class="form-control rounded"
                                                name="questionBase[description]" :value="this.description">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{ __('forms.Question.sorting') }}</label>
                                            <input type="number" class="form-control rounded"
                                                name="questionBase[sorting]" :value="this.sorting">
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="mb-2">
                                    <h3 class="text-primary">
                                        {{
                                            __("forms.EvaluationChart.questions.questions_setting.question42.available_sources")
                                        }}
                                    </h3>

                                    <label>
                                        {{
                                            __("forms.EvaluationChart.questions.questions_setting.question42.info_sources")
                                        }}
                                    </label>
                                </div>

                                <div class="row px-3" v-for="(plan, index) in sortedAvailablePlans" :key="plan.id">
                                    <div class="col-12" :draggable="can_write"
                                        @dragstart="handleDragStart($event, index)"
                                        @dragenter="handleDragEnter($event, index)"
                                        @dragleave="handleDragLeave($event)"
                                        @dragover="handleDragOver($event, index)" @drop="handleDrop($event, index)"
                                        @dragend="handleDragEnd($event)"
                                        style="cursor: move; border: 1px solid #e0e0e0; border-radius: 5px;">
                                        <div class="row align-items-center">
                                            <div class="col-1" v-if="can_write">
                                                <i class="fas fa-grip-vertical text-muted"></i>
                                            </div>
                                            <div class="col-6">
                                                {{ plan.name }}
                                            </div>
                                            <div class="col-5">
                                                <div class='form-group'>
                                                    <div class="custom-control custom-switch">
                                                        <input
                                                            name="questionSettings[selected_kpis_incentive_plans_list][]"
                                                            type="checkbox" class="custom-control-input"
                                                            :id="'selected_kpis_incentive_plan-' + plan.id"
                                                            :value="plan.id"
                                                            :checked="selected_kpis_incentive_plans_list.includes(plan.id)"
                                                            @change="togglePlanSelection(plan.id)" />
                                                        <label class="custom-control-label"
                                                            :for="'selected_kpis_incentive_plan-' + plan.id">
                                                            {{
                                                                __('forms.EvaluationChart.questions.questions_setting.question42.show_plan')
                                                            }}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <input type="hidden"
                                            :name="'questionSettings[plans_order][' + plan.id + ']'"
                                            :value="plan.sort || index" />
                                    </div>
                                </div>
                            

                                <div class="row">
                                    <div class="col-12">
                                        <hr>
                                    </div>
                                    <div class="col-12 mt-3 text-right" v-if="can_write">
                                        <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </section>
                </section>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {

    props: {
        can_write: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            //default
            title: "",
            active: false,
            action: "",
            name: "",
            description: "",
            sorting: -1,
            editing: true,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            available_plans: [],
            selected_kpis_incentive_plans_list: [],
            draggedIndex: null,

        }
    },
    computed: {
        sortedAvailablePlans() {
            return [...this.available_plans].sort((a, b) => {
                // Prima controlla se sono entrambi selezionati e ordina in base alla posizione in selected_kpis_incentive_plans_list
                const indexA = this.selected_kpis_incentive_plans_list.indexOf(a.id);
                const indexB = this.selected_kpis_incentive_plans_list.indexOf(b.id);
                
                // Se entrambi sono selezionati, ordina in base alla loro posizione nell'array
                if (indexA !== -1 && indexB !== -1) {
                    return indexA - indexB;
                }
                
                // Se solo A è selezionato, mettilo prima
                if (indexA !== -1 && indexB === -1) {
                    return -1;
                }
                
                // Se solo B è selezionato, mettilo prima
                if (indexA === -1 && indexB !== -1) {
                    return 1;
                }
                
                // Se nessuno dei due è selezionato, usa l'ordinamento standard
                const sortA = a.sort !== undefined ? a.sort : 0;
                const sortB = b.sort !== undefined ? b.sort : 0;
                return sortA - sortB;
            });
        }
    },
    methods: {
        handleDragStart(event, index) {
            this.draggedIndex = index;
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/html', event.target);
        },
        handleDragEnter(event, index) {
            if (this.draggedIndex !== index) {
                event.target.style.borderColor = '#4CAF50';
            }
        },
        handleDragLeave(event) {
            event.target.style.borderColor = '#e0e0e0';
        },
        handleDragOver(event, index) {
            event.preventDefault();
            event.dataTransfer.dropEffect = 'move';
            return false;
        },
        handleDrop(event, dropIndex) {
            event.preventDefault();
            event.stopPropagation();

            if (this.draggedIndex === null || this.draggedIndex === dropIndex) return false;

            const sortedPlans = [...this.sortedAvailablePlans];
            const draggedItem = sortedPlans[this.draggedIndex];

            // Rimuovi l'elemento dalla posizione originale
            sortedPlans.splice(this.draggedIndex, 1);
            // Inseriscilo nella nuova posizione
            sortedPlans.splice(dropIndex, 0, draggedItem);

            // Aggiorna i valori sort in base al nuovo ordine
            sortedPlans.forEach((plan, idx) => {
                const originalPlan = this.available_plans.find(p => p.id === plan.id);
                if (originalPlan) {
                    this.$set(originalPlan, 'sort', idx);
                }
            });

            // Aggiorna anche selected_kpis_incentive_plans_list per riflettere il nuovo ordine
            const newSelectedOrder = [];
            sortedPlans.forEach(plan => {
                if (this.selected_kpis_incentive_plans_list.includes(plan.id)) {
                    newSelectedOrder.push(plan.id);
                }
            });
            // Aggiungi eventuali ID selezionati che non erano nella lista trascinata
            this.selected_kpis_incentive_plans_list.forEach(planId => {
                if (!newSelectedOrder.includes(planId)) {
                    newSelectedOrder.push(planId);
                }
            });
            this.selected_kpis_incentive_plans_list = newSelectedOrder;

            // Forza il re-render
            this.$forceUpdate();

            return false;
        },
        handleDragEnd(event) {
            this.draggedIndex = null;
            // Reset border color only for form groups inside this form
            const elements = document.querySelectorAll('.form-group');
            elements.forEach(el => {
                el.style.borderColor = '#e0e0e0';
            });
        },
        togglePlanSelection(planId) {
            const index = this.selected_kpis_incentive_plans_list.indexOf(planId);
            if (index > -1) {
                // Se è già selezionato, rimuovilo
                this.selected_kpis_incentive_plans_list.splice(index, 1);
            } else {
                // Se non è selezionato, aggiungilo
                this.selected_kpis_incentive_plans_list.push(planId);
            }
        },
        toggle(action, item_id, editing, attributes) {
            this.active = true;
            this.action = action;
            this.editing = editing;
            this.lang = attributes.lang;
            let dataRoute = decodeURI(attributes.dataRoute);
            if (dataRoute !== undefined) {
                if (dataRoute.indexOf("[id]") > 0) {
                    dataRoute = dataRoute.replace("[id]", item_id);

                }
                axios.get(dataRoute)
                    .then((response) => {
                        
                        this.name = response.data.base.name;
                        this.description = response.data.base.description;
                        this.sorting = response.data.base.sorting;
                        this.can_write = app.__vue__.questionPermission(this.can_write, response.data.base.enable);
                        this.available_plans = response.data.available_plans;
                        this.selected_kpis_incentive_plans_list = response.data.selected_kpis_incentive_plans_list;

                    });
            }
        }

    }

}
</script>
